import { render, staticRenderFns } from "./QTable.vue?vue&type=template&id=5d24a2ae"
import script from "./QTable.vue?vue&type=script&lang=js"
export * from "./QTable.vue?vue&type=script&lang=js"
import style0 from "./QTable.vue?vue&type=style&index=0&id=5d24a2ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports